import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-SidebarRecommendations",
  "use": "svg-icon-SidebarRecommendations-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-SidebarRecommendations\"><g fill=\"none\" fill-rule=\"evenodd\"><path opacity=\".5\" d=\"M0 0h24v24H0z\" /><path d=\"M8 18v-2c0-1-4-4-4-8a8 8 0 1 1 16 0c0 4-4.017 6.94-4 8 .011.707.011 1.374 0 2H8zm0 2h8v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2z\" fill=\"#D8D8D8\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol